import React from 'react';
import PropTypes from 'prop-types';

// PrimeReact UI components
import {Checkbox} from 'primereact/checkbox';
import {ReleaseDecadeList} from '../catalog/catalog-constants';

// Styles
import 'primereact/resources/themes/nova-light/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';

const releaseDecadePicker = ({criteriaId, existingReleaseDecades, onChange}) => {
    const options = new Array();

    for (let i = 0; i < ReleaseDecadeList.length; i++) {
        let checked = false;

        if (existingReleaseDecades) {
            const enumValue = ReleaseDecadeList[i].decadeName;

            for (let r = 0; r < existingReleaseDecades.length; r++) {
                const decade = existingReleaseDecades[r];
                if (enumValue == decade) {
                    checked = true;
                    break;
                }
            }
        }

        options.push(
            <div style={{display: 'inline-block'}}>
                <Checkbox
                    checked={checked}
                    id={`releaseDecade${criteriaId}_${i}`}
                    inputId={`releaseDecade${criteriaId}_${i}`}
                    onChange={onChange}
                />
                <label className="p-checkbox-label" htmlFor={`releaseDecade${criteriaId}_${i}`}>
                    {ReleaseDecadeList[i].label}
                </label>
            </div>
        );
    }

    return (
        <div className="p-grid">
            {' '}
            <div className="p-col">{options}</div>
        </div>
    );
};

releaseDecadePicker.propTypes = {
    criteriaId: PropTypes.number.isRequired,
    existingReleaseDecades: PropTypes.array.isRequired,
    onChange: PropTypes.func.isRequired,
};

export default releaseDecadePicker;
